export const PageTabs = {
  Pharmacies: 0,
  Products: 1,
};

export const PageTabsOptions = [
  {
    label: 'Pharmacies',
    value: 0,
  },
  {
    label: 'Products',
    value: 1,
  },
];
